import React from "react";

//Lets an artwork page fill in the Contact Us form (in the footer) and scroll down to it
const EnquiryContext = React.createContext({ prefill: null, startEnquiry: () => {} });

export const CONTACT_FORM_ID = "contact";

export const EnquiryProvider = ({ children }) => {
  const [prefill, setPrefill] = React.useState(null);

  const startEnquiry = React.useCallback((artwork, artistName) => {
    //New object every time, so asking about the same artwork again still refills the form
    setPrefill({ artwork: artwork.name, artist: artistName || "", key: Date.now() });
    const form = document.getElementById(CONTACT_FORM_ID);
    if (form) {
      form.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, []);

  const value = React.useMemo(() => ({ prefill, startEnquiry }), [prefill, startEnquiry]);

  return (
    <EnquiryContext.Provider value={value}>
      {children}
    </EnquiryContext.Provider>
  );
};

export const useEnquiry = () => React.useContext(EnquiryContext);
